export default {"src":"/_next/static/media/courier.1aa46f40.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};